// Minimum number of qualifying new conversations (after any cooldown ends)
// before the CSAT survey becomes eligible to show.
export const MIN_QUALIFYING_CONVERSATIONS: number = 3;
